import type { ListenerEffectAPI } from "@reduxjs/toolkit";
import { removeStorageObjectLocal } from "../../../../../app/state/storageObjectSlice/slice";
import type { AppDispatch, RootState } from "../../../types";
import { appListenerMiddleware } from "../../appListenerMiddleware";
import { serviceHandlers } from "../handlers/storageHandlers";

export function deleteStorageObjectListener() {
  appListenerMiddleware.startListening({
    actionCreator: removeStorageObjectLocal,
    effect: async (action, listenerApi) => {
      const { service, id, object } = action.payload;
      const removedValue = object.value;

      if (!removedValue) return;

      const handler = serviceHandlers[service];

      if (handler?.onDelete) {
        await handler.onDelete(
          listenerApi as ListenerEffectAPI<RootState, AppDispatch>,
          id,
          removedValue
        );
      }
    },
  });
}
